module.exports = __webpack_public_path__ + "media/Great_grandmother.7cfc27c2.mp3";